import React from "react";
import { useAuthorization } from "@common/providers";
import ScopeStackSpinner from "@components/ScopeStackSpinner/ScopeStackSpinner";
import { Route, Routes } from "react-router";
import List from "./List/List";
import { useV2GetAccountQuery } from "@generated";
import usePrivilegeCheck from "@common/hooks/usePrivilegeCheck";
import Edit from "./Edit/Edit";
import New from "./New/New";

const DocumentTemplatesMspa = (): JSX.Element => {
  // Get Account
  const {
    data: account,
    error: accountError,
    isLoading: accountLoading,
    refetch: accountRefetch,
  } = useV2GetAccountQuery({
    include: ["phases", "resources"],
  });

  // Get permissions for current user
  const { accessLevel, privilegesLoading, user } = usePrivilegeCheck();

  const authorized = useAuthorization();
  if (
    !authorized ||
    !account ||
    accountLoading ||
    !user ||
    privilegesLoading
  ) {
    return <ScopeStackSpinner />;
  }

  const documentTemplatePermission = accessLevel("settings.sow_templates");

  return (
    <Routes>
      <Route
        path="/"
        element={<List permission={documentTemplatePermission} />}
      />
      <Route
        path="/edit/:documentTemplateId"
        element={
          <Edit account={account} permission={documentTemplatePermission} />
        }
      />
      <Route
        path="/new"
        element={
          <New account={account} permission={documentTemplatePermission} />
        }
      />
    </Routes>
  );
};

export default DocumentTemplatesMspa;
